import { facebookDeprecationDate } from './constants';

export type TLanguage = {
    login: {
        header: {
            consumer: string;
            staff: {
                subscriber: string;
                account: string;
            };
        };
        username: {
            consumer: string;
            staff: string;
        };
        forgotPassword: {
            desc: string;
            cta: string;
            staffCta: string;
        };
        checkEmailCTA: string;
        loginCTA: string;
        loginFacebookCTA: string;
        loginFacebookHelp: string;
        loginGoogleCTA: string;
        loginAppleCTA: string;
        createAccount: {
            desc: string;
            cta: string;
        };
        thirdParty: {
            disconnectDesc: string;
            cta: string;
        };
        createAccountFamilyFirst: {
            desc: string;
            cta: string;
            details: string;
        };
        error: {
            loginInvalid: string;
            loginLocked: string;
            consumerLoginLocked: string;
            consumerLoginLockedMessage: string;
            passwordExpired: string;
            manualMigrationRequired: string;
            subscriberConsumerConflict: string;
            subscriberConsumerExistingLink: string;
            adminStaffSignin: string;
            noPermissions: string;
            generic: string;
        };
        notConsumer: {
            cta: string;
        };
        onlyStaff: string;
        bookService: string;
        continueWith: string;
        createAccountWith: string;
        enterPassword: string;
    };
    deprecateFacebook: {
        warning: {
            title: string;
            desc: string;
            back: string;
            cta: string;
        };
        password: {
            title: string;
            desc: string;
            cta: string;
        };
        success: {
            title: string;
            desc: (email: string) => string;
            cta: string;
        };
    };
    logout: {
        confirm: {
            header: string;
            cta: string;
        };
        success: {
            header: string;
        };
    };
    forgotPassword: {
        header: string;
        subheader: string;
        subheaderPasscode: string;
        desc: string;
        spamCheck: string;
        submitEmailCTA: string;
        sendPasscodeCTA: string;
        cantAccessEmailCta: string;
        success: {
            header: string;
            subheader: string;
            desc: string;
            disclaimer: string;
        };
        linkExpired: {
            header: string;
            subheader: string;
            submitEmailCTA: string;
        };
        error: {
            locked: string;
            lockedMessage: string;
        };
    };
    resetPassword: {
        header: string;
        newPasswordLabel: string;
        confirmNewPasswordLabel: string;
        submitPasswordCTA: string;
        success: {
            header: string;
            subheader: string;
            cta: string;
        };
        passwordsDontMatch: string;
    };
    createAccount: {
        header: string;
        desc: string;
        headerFamilyFirst: string;
        descFamilyFirst: string;
        createAccountWithEmailCTA: string;
        createAccountCTA: string;
        createFamilyAccountCTA: string;
        existingAccountDesc: string;
        existingAccountCTA: string;
        createFamilyCta: string;
        familyFirstSkipFamily: string;
        form: {
            firstName: string;
            lastName: string;
            email: string;
            password: string;
            phone: string;
            country: string;
        };
        pending: {
            header: string;
            desc: string;
            descCTA: string;
        };
        passcode: {
            header: string;
            desc: string;
            desc2: string;
            cta: {
                verify: string;
                resendPasscode: string;
            };
            error: {
                invalid: string;
                generic: string;
                locked: string;
            };
        };
    };
    createFamilyAccount: {
        header: string;
        desc: string;
        details: string;
        primaryUser: {
            title: string;
            cta: string;
        };
        itemHeader: string;
        itemsHeader: string;
        addItemCta: string;
        maxItems: string;
        confirmHeader: string;
        manualLink: {
            desc: string;
            confirmAccountDesc: string;
            primaryUserTitle: string;
            familyUsersTitle: string;
            addUser: string;
        };
        editFamilyCta: string;
    };
    register: {
        header: string;
        createAccountCTA: string;
        firstName: string;
        lastName: string;
        countryRequired: string;
    };
    verify: {
        header: string;
        desc: {
            singleUser: {
                hasLinks: string;
                noLinks: string;
            };
        };
        otherBusiness: string;
        moreBusinessesCta: string;
        findBusinessesCta: string;
        loginCta: string;
        cobrandedLoginCta: string;
        autoLogin: string;
        error: {
            header: string;
            subhead: string;
            cta: string;
        };
        sendSuccess: string;
        loader: string;
    };
    verifyStaff: {
        header: string;
        loginCta: string;
        autoLogin: string;
        desc: {
            generic: string;
            customer: string;
        };
    };
    unverified: {
        header: string;
        desc: string;
        descCTA: string;
        descStaff: string;
        descStaffCTA: string;
        resendEmail: string;
        resendSuccess: string;
    };
    changeEmail: {
        header: string;
        desc: string;
        staffDesc: string;
    };
    validation: {
        email: string;
        emailMissing: string;
        emailMaxLength: string;
        username: string;
        genericError: string;
        accountLocked: string;
        password: {
            invalid: string;
            length: string;
            uppercase: string;
            lowercase: string;
            special: string;
            all: string;
        };
        accountExists: {
            header: string;
            desc: string;
        };
        firstName: string;
        lastName: string;
        firstNameInvalid: string;
        lastNameInvalid: string;
        firstNameMaxLength: string;
        lastNameMaxLength: string;
        mobilePhone: string;
        maxLength: string;
        legal: string;
    };
    accountMigration: {
        title: string;
        desc: string;
        password: string;
        cta: string;
        success: {
            header: string;
            desc: string;
            cta: string;
        };
    };
    staffAccountMigration: {
        email: {
            title: {
                confirm: string;
                confirmNoName: string;
                add: string;
                addNoName: string;
            };
            desc: {
                confirm: string;
                confirmNoName: string;
                add: string;
                addNoName: string;
            };
            userExists: string;
            login: string;
        };
        password: {
            title: string;
            subtitle: string;
            subhead: string;
            confirmPassword: string;
        };
        verify: {
            title: string;
            desc: string;
            cta: string;
        };
        success: {
            title: string;
            desc: string;
            desc2: string;
            cta: string;
        };
    };
    migrateToExistingAccount: {
        verify: {
            title: string;
            desc: string;
            disclaimer: string;
        };
        confirm: {
            title: string;
            desc: string;
            cta: string;
            primaryUser: string;
            dependentUsers: string;
        };
    };
    confirmAccount: {
        title: string;
        password: string;
        success: string;
        defaultBusinessName: string;
        addOwner: {
            title: string;
            desc: string;
            cta: string;
        };
        family: {
            title: string;
            familyFirstTitle: string;
            desc: string;
            familyFirstDesc: string;
            addCta: string;
            skipCta: string;
        };
        confirm: {
            title: string;
            desc: string;
            cta: string;
        };
    };
    confirmStaffAccount: {
        header: string;
        confirmPhone: {
            header: string;
            desc: string;
            verifyDesc: string;
            sendWith: string;
            resendCode: string;
            resendCodeCta: string;
            invalidCode: string;
            skip: string;
        };
        exists: {
            header: string;
            desc: string;
        };
        expired: {
            header: string;
            desc: string;
            desc2: string;
            cta: string;
            success: string;
        };
        success: {
            header: string;
            desc: string;
            loginCta: string;
        };
    };
    multiFactorAuth: {
        header: string;
        desc: string;
        inputDesc: string;
        verifyCta: string;
        error: {
            invalidCode: string;
            accountLocked: string;
        };
        troubleshooting: {
            header: string;
            optionOne: string;
            optionTwo: string;
        };
    };
    multiFactorAuthRecovery: {
        header: string;
        desc: string;
        inputDesc: string;
        verifyCta: string;
        error: {
            invalidCode: string;
        };
        troubleshooting: {
            optionOne: string;
            optionTwo: string;
        };
    };
    multiFactorAuthDisabled: {
        header: string;
        message: string;
    };
    common: {
        email: string;
        newEmail: string;
        password: string;
        show: string;
        hide: string;
        or: string;
        country: string;
        and: string;
        mb: string;
        poweredByMb: string;
        back: string;
        back2: string;
        next: string;
        you: string;
        delete: string;
        thanks: string;
        step: string;
        family: string;
        phone: string;
        mobilePhone: string;
        text: string;
        call: string;
        cancel: string;
        confirm: string;
        seconds: string;
        second: string;
        firstName: string;
        lastName: string;
        hello: string;
        edit: string;
        apple: string;
        facebook: string;
        google: string;
        digit: string;
        error: string;
    };
    legal: {
        privacyPolicy: string;
        privacyRights: string;
        termsService: string;
        termsUse: string;
        consumerAgreement: string;
        createAccountAgreement: string;
        createAccountAgreementCheckbox: string;
    };
    marketing: {
        marketingOptIn: string;
    };
    agreeToTerms: {
        title: string;
        desc: {
            start: string;
            end: string;
        };
        label: string;
        cta: string;
    };
    partnerConsent: {
        title: string;
        desc: string;
        formlabel: string;
        cta: string;
        disclaimer: string;
    };
    error: {
        generic: {
            header: string;
            subheader: string;
        };
        thirdPartyGeneric: {
            header: string;
            loginCTA: string;
        };
        thirdPartyConnected: {
            header: string;
            subheader: string;
            loginCTA: string;
        };
        noCoporateUserFound: {
            header: string;
            subheader: string;
        };
        corporateUserConflict: {
            header: string;
            subheader: string;
        };
        corporateUserNoPermission: {
            header: string;
            subheader: string;
        };
    };
    unsupported: {
        unsupportedBrowser: {
            header: string;
            desc: string;
            chrome: string;
            firefox: string;
            edge: string;
            safari: string;
        };
        cookiesDisabled: {
            header: string;
            desc: string;
        };
    };
};

const language: TLanguage = {
    login: {
        header: {
            consumer: 'Sign in',
            staff: {
                subscriber: 'Staff sign-in',
                account: 'Sign in',
            },
        },
        username: {
            consumer: 'Email',
            staff: 'Email or username',
        },
        forgotPassword: {
            desc: 'Forgot your password?',
            cta: 'Reset it here',
            staffCta: 'Forgot password',
        },
        checkEmailCTA: 'Continue',
        loginCTA: 'Sign In',
        loginFacebookCTA: 'Continue with Facebook',
        loginFacebookHelp: 'Facebook help?',
        loginGoogleCTA: 'Continue with Google',
        loginAppleCTA: 'Continue with Apple',
        createAccount: {
            desc: 'New here?',
            cta: 'Create an account',
        },
        thirdParty: {
            disconnectDesc: 'Prefer not to sign\u2013in with <provider>?',
            cta: 'Disconnect here',
        },
        createAccountFamilyFirst: {
            desc: 'New here?',
            cta: 'Create your family account',
            details: 'Adding family to your Mindbody account allows you to easily book and pay for your children.',
        },
        error: {
            loginInvalid: 'Please check your email and password',
            consumerLoginLocked: 'Too many attempts, account is locked.',
            consumerLoginLockedMessage: '<link>Reset your password</link> and try logging in again after 30 minutes.',
            loginLocked: 'Account is locked (too many attempts)',
            passwordExpired: 'Expired admin credentials—update them at',
            manualMigrationRequired:
                'This login is no longer supported. <link>View the Migration Guide</link> for steps to reconnect to your account',
            subscriberConsumerConflict:
                'Incorrect password for the Mindbody account linked to <email>. To access your account, <link>reset your password</link>.',
            subscriberConsumerExistingLink:
                'Incorrect password for the Mindbody account linked to <email>. To access your account, <link>reset your password</link>',
            adminStaffSignin: 'Mindbody Admin users must sign in using the <link>Client Site Login tool</link>.',
            noPermissions: "You don't have permission to access this site",
            generic: 'Sorry something went wrong please try again later',
        },
        notConsumer: {
            cta: 'Staff\u2013sign in',
        },
        onlyStaff: 'This sign-in is for staff only.',
        bookService: 'Looking to book a service?',
        continueWith: 'Continue with',
        createAccountWith: 'Create an account with',
        enterPassword: 'Enter your Mindbody password to continue',
    },
    deprecateFacebook: {
        warning: {
            title: 'We will no longer be supporting Facebook login',
            desc: `Please transition your account by ${facebookDeprecationDate}. To do this, log in to Facebook by clicking "Continue" and set a new password that you'll use from now on.`,
            back: 'Go back',
            cta: 'Continue',
        },
        password: {
            title: 'Finish transitioning your Facebook account',
            desc: 'Please set a new password for this account.',
            cta: 'Finish',
        },
        success: {
            title: 'Thanks!',
            desc: (email) =>
                `Your account has been transitioned! You can now use ${email} and your new password to login moving forward.`,
            cta: 'Finish',
        },
    },
    logout: {
        confirm: {
            header: 'Do you want to sign out?',
            cta: 'Sign out',
        },
        success: {
            header: 'All done. You have successfully signed out',
        },
    },
    forgotPassword: {
        header: 'Forgot password',
        subheader: "We'll send you a link to reset it",
        subheaderPasscode: "We'll email you a verification code to reset it",
        desc: "You'll get a message soon at",
        spamCheck: 'If nothing shows up, check your spam folder.',
        submitEmailCTA: 'Send Link',
        sendPasscodeCTA: 'Send code',
        cantAccessEmailCta: "I can't access my email",
        success: {
            header: 'Check your inbox',
            subheader: "You'll get a message soon at",
            desc: "If you have an account, you'll get a message soon. (Not seeing it? Check your spam folder.)",
            disclaimer: 'If nothing shows up, check your spam folder.',
        },
        linkExpired: {
            header: 'Something went wrong',
            subheader: 'Enter your email to get a new link',
            submitEmailCTA: 'Send New Link',
        },
        error: {
            locked: 'Too many reset attempts, account is locked.',
            lockedMessage: 'Try resetting your password again after 60 minutes.',
        },
    },
    resetPassword: {
        header: 'Set a new password',
        newPasswordLabel: 'New Password',
        confirmNewPasswordLabel: 'Confirm new password',
        submitPasswordCTA: 'Set Password',
        success: {
            header: 'Password set!',
            subheader: 'You can now sign in with your new password.',
            cta: 'Return to Sign In',
        },
        passwordsDontMatch: "Passwords don't match",
    },
    createAccount: {
        header: 'Create a Mindbody account',
        desc: 'Sign up using your email',
        headerFamilyFirst: 'Create a Mindbody family account',
        descFamilyFirst: 'Adding family to your account allows you to easily book and pay for your children ',
        createAccountWithEmailCTA: 'Continue with Email',
        createAccountCTA: 'Continue',
        createFamilyAccountCTA: 'Yes, create this family account',
        existingAccountDesc: 'Already have a Mindbody account?',
        existingAccountCTA: 'Sign in',
        createFamilyCta: 'Add family',
        familyFirstSkipFamily: 'Create account without family',
        form: {
            firstName: 'First name',
            lastName: 'Last name',
            email: 'Email',
            password: 'Password',
            phone: 'Phone',
            country: 'Country',
        },
        pending: {
            header: 'Check your inbox',
            desc: 'Verify your email using the link we sent. Once you’ve finished verification, you’ll be able to book and browse.',
            descCTA: 'Sign In',
        },
        passcode: {
            header: 'Verify your email',
            desc: 'To confirm your account please enter the passcode sent to',
            desc2: 'Check your spam folder or request a new code',
            cta: {
                verify: 'Verify',
                resendPasscode: 'Request new code',
            },
            error: {
                invalid: 'Invalid code',
                locked: 'Account is locked (too many attempts)',
                generic: 'Something went wrong please try again later',
            },
        },
    },
    createFamilyAccount: {
        header: 'Add a Family Member',
        desc: "Only add someone if you plan to book and pay for them. They won't have an account of their own.",
        details: 'This person is in charge of booking and paying for children on the account.',
        primaryUser: {
            title: 'Account owner',
            cta: 'Not you?',
        },
        itemHeader: 'Family member',
        itemsHeader: 'Family members',
        addItemCta: 'Add another',
        maxItems: 'After you verify your account, you can add more family on',
        confirmHeader: 'Create this family account?',
        manualLink: {
            desc: 'You signed in as <name>, which family member would you like to assign as <name>?',
            confirmAccountDesc: 'Which family member would you like to assign as <name>?',
            primaryUserTitle: 'Account owner',
            familyUsersTitle: 'Family',
            addUser: 'Add <name> as family',
        },
        editFamilyCta: 'Edit family',
    },
    register: {
        header: 'Create an account',
        createAccountCTA: 'Create Account',
        firstName: 'First name (optional)',
        lastName: 'Last name (optional)',
        countryRequired:
            'Your privacy is our top priority. We collect your country so we can adhere to data privacy regulations in your region.',
    },
    changeEmail: {
        header: 'Updated',
        desc: 'You can now use this email to sign in at businesses that use Mindbody',
        staffDesc: 'You can now use this email to sign in at <accountName>',
    },
    verify: {
        header: 'Your email is verified',
        desc: {
            singleUser: {
                noLinks:
                    "Now you can use this email and password to sign in to any business that's powered by Mindbody.",
                hasLinks:
                    "We see that your email address has been used at other businesses that use Mindbody. We've linked them to your Mindbody account so signing in to all your favorite businesses is easy (just use your Mindbody account email and password).",
            },
        },
        otherBusiness: "Think you've visited a business that's not here?",
        moreBusinessesCta: 'View more businesses',
        findBusinessesCta: 'Search for them',
        loginCta: 'Continue booking and browsing',
        cobrandedLoginCta: 'Continue to <businessName>',
        autoLogin: 'You will be automatically redirected in <secondsLeft> <secondsLabel>',
        error: {
            header: 'Something went wrong',
            subhead: 'This link might be expired, we can send you a new link',
            cta: 'Send me a new link',
        },
        sendSuccess: 'Email sent',
        loader: 'Verifying email address...',
    },
    verifyStaff: {
        header: 'Your email is verified',
        loginCta: 'Continue to Your Business',
        autoLogin: 'You will be automatically redirected in <secondsLeft> <secondsLabel>',
        desc: {
            generic: 'Thank you for verifying your email',
            customer: 'Thank you for verifying your email at <customerAccountName>',
        },
    },
    unverified: {
        header: 'Verify your email',
        desc: 'Verify your email using the link we sent. Then you can',
        descCTA: 'keep booking and browsing.',
        descStaff: 'Verify your email using the link we sent. Then you can',
        descStaffCTA: 'continue signing in',
        resendEmail: 'Resend Link',
        resendSuccess: 'Sent',
    },
    validation: {
        email: 'Please enter a valid email',
        emailMissing: 'Please enter an email',
        emailMaxLength: 'Email can not be longer than 255 characters',
        username: 'Please enter a valid username',
        genericError: 'Sorry something went wrong please try again later',
        accountLocked: 'Account is locked (too many attempts)',
        accountExists: {
            header: 'A Mindbody account with this email already exists',
            desc: 'Enter a new email address or sign in with your Mindbody account password.',
        },
        password: {
            invalid: 'Please enter a valid password',
            length: 'Between 8 and 30 characters',
            uppercase: 'At least one upper case letter',
            lowercase: 'At least one lower case letter',
            special: 'At least one number or special character',
            all: 'Password meets requirements',
        },
        firstName: 'Please enter a first name',
        lastName: 'Please enter a last name',
        firstNameInvalid: 'Please enter a valid first name',
        lastNameInvalid: 'Please enter a valid last name',
        firstNameMaxLength: 'First name can not be longer than 100 characters',
        lastNameMaxLength: 'Last name can not be longer than 100 characters',
        maxLength: '<noun> can not be longer than <length> characters',
        mobilePhone: 'Please enter a valid mobile phone number',
        legal: 'Please agree to our Privacy Policy and Terms of Use',
    },
    accountMigration: {
        title: "We're updating your account",
        desc: 'Your account will now work for all Mindbody-powered businesses.',
        password: 'Strengthen your password',
        cta: 'Continue',
        success: {
            header: 'Success!',
            desc: 'Your account has been upgraded to Mindbody.',
            cta: 'Finish',
        },
    },
    staffAccountMigration: {
        email: {
            title: {
                confirm: 'Confirm your email address',
                confirmNoName: 'Confirm your information',
                add: 'Add your email address',
                addNoName: 'Add your information',
            },
            desc: {
                confirm:
                    'Hi <firstName>, make sure this email account is unique to you and you can access it to verify your identity.',
                confirmNoName:
                    'Make sure this email account is unique to you and you can access it to verify your identity.',
                add: 'Hi <firstName>! Now you can use an email address as your username, allowing you to set/change your own password. Just make sure the email is unique to you.',
                addNoName:
                    'Now you can use an email address as your username, allowing you to set/change your own password. Just make sure the email is unique to you.',
            },
            userExists: 'This email address is already in use',
            login: 'Sign in with this email',
        },
        password: {
            title: 'Re-enter password',
            subtitle: '(or set a new one)',
            subhead: "If your current password doesn't meet the guidelines shown, you'll have to set a new one.",
            confirmPassword: 'Confirm password',
        },
        verify: {
            title: "You're almost done",
            desc: 'To access your account more securely, use the verification link we sent to:',
            cta: 'Continue Signing In',
        },
        success: {
            title: "You're all set",
            desc: "Use <email> to sign in going forward. You'll receive a verification email, but you can sign in immediately",
            desc2: 'Check your inbox later to complete verification.',
            cta: 'Continue Signing In',
        },
    },
    migrateToExistingAccount: {
        verify: {
            title: 'This email is connected to another account',
            desc: 'For security please enter the 6-digit code we sent to',
            disclaimer: 'Check your spam folder or request a new code',
        },
        confirm: {
            title: 'Your accounts are now connected!',
            desc: 'You can now book, buy, and manage all members by logging into the account owner profile',
            cta: 'Finish',
            primaryUser: 'Account owner',
            dependentUsers: 'Family members',
        },
    },
    confirmAccount: {
        title: 'Confirm your information',
        password: 'Strengthen your password',
        success: 'Account Created!',
        defaultBusinessName: 'this business',
        addOwner: {
            title: 'Select the owner of this family account',
            desc: 'The account owner is responsible for booking and buying for all family members on the account',
            cta: 'Add an account owner',
        },
        family: {
            title: 'Do you book for family members?',
            familyFirstTitle: 'Add family',
            desc: "Let us know who you book and pay for. We'll add them to your Mindbody account (but they won't have an account of their own).",
            familyFirstDesc: "Let us know who you book and pay for. We'll add them to your Mindbody account.",
            addCta: 'Add Person',
            skipCta: 'Skip',
        },
        confirm: {
            title: 'Almost done!',
            desc: "Next we'll send you an email to verify your email address. After, you'll be able to use this email and password to sign in to <businessName>. Your other password will no longer work.",
            cta: 'Create Account',
        },
    },
    confirmStaffAccount: {
        header: 'Confirm your information',
        confirmPhone: {
            header: 'Confirm your phone',
            desc: "We'll send you a code to verify your mobile phone",
            verifyDesc: 'Enter the confirmation code we sent to <phoneNumber>',
            sendWith: 'Send code via',
            resendCode: 'Having trouble?',
            resendCodeCta: 'Resend Code',
            invalidCode: 'Sorry, the code you entered is invalid',
            skip: 'Skip',
        },
        exists: {
            header: "You're all set",
            desc: 'Your email is already verified',
        },
        expired: {
            header: 'This link is expired',
            desc: 'We can send you a new link',
            desc2: 'Please contact the business to have them send a new link',
            cta: 'Send new link',
            success: 'Email sent',
        },

        success: {
            header: "You're all set",
            desc: "Don't forget to download the Mindbody business app so you can keep track of your schedule",
            loginCta: 'Continue to sign in',
        },
    },
    multiFactorAuth: {
        header: 'Verify Your Identity',
        desc: "Enter the code generated by your authenticator app. To return to the previous page, use your browser's back button.",
        inputDesc: 'Verification Code:',
        verifyCta: 'Verify',
        error: {
            invalidCode: 'Invalid code',
            accountLocked: 'Account is locked (too many attempts)',
        },
        troubleshooting: {
            header: 'Trouble accessing your code?',
            optionOne: 'Use a backup code',
            optionTwo: 'view Mindbody support article',
        },
    },
    multiFactorAuthRecovery: {
        header: 'Verify With Backup Code',
        desc: "These single-use codes were issued during MFA setup for cases when you couldn't access your authenticator app",
        inputDesc: 'Backup Code:',
        verifyCta: 'Verify',
        error: {
            invalidCode: 'The code is invalid. Try again',
        },
        troubleshooting: {
            optionOne: 'Use a verification code',
            optionTwo: 'view Mindbody support article',
        },
    },
    multiFactorAuthDisabled: {
        header: 'Multi-Factor Authentication is removed',
        message: 'You can re-enable this setting at any time from the My Account Information page.',
    },
    common: {
        email: 'Email',
        newEmail: 'New email address',
        password: 'Password',
        show: 'Show',
        hide: 'Hide',
        or: 'or',
        and: 'and',
        country: 'Country',
        mb: 'Mindbody',
        poweredByMb: 'Powered by Mindbody',
        back: 'Back',
        back2: 'Go back',
        next: 'Next',
        you: 'you',
        delete: 'Delete',
        thanks: 'Thanks',
        step: 'Step',
        family: 'family',
        phone: 'Phone',
        mobilePhone: 'Mobile phone',
        text: 'Text',
        call: 'Call',
        cancel: 'Cancel',
        confirm: 'Confirm',
        seconds: 'seconds',
        second: 'second',
        firstName: 'First name',
        lastName: 'Last name',
        hello: 'Hello',
        edit: 'Edit',
        apple: 'Apple',
        facebook: 'Facebook',
        google: 'Google',
        digit: 'digit',
        error: 'Error',
    },
    legal: {
        privacyPolicy: 'Privacy Policy',
        privacyRights: 'Your Privacy Rights',
        termsService: 'Terms of Service',
        termsUse: 'Terms of Use',
        consumerAgreement: 'Consumer Agreement',
        createAccountAgreement: 'By creating an account, you agree to our',
        createAccountAgreementCheckbox: 'I agree to the Mindbody',
    },
    marketing: {
        marketingOptIn: 'Send me emails with the latest news and promos',
    },
    agreeToTerms: {
        title: "We've updated our Terms of Use and Privacy Policy",
        desc: {
            start: 'We take security seriously. Take a moment to read and agree to our most recent <termsLink>Terms of Use</termsLink>',
            end: 'and <privacyLink>Privacy Policy</privacyLink>',
        },
        label: 'I agree to the Mindbody Terms of Use and Privacy Policy.',
        cta: 'Save',
    },
    partnerConsent: {
        title: '<partnerName> is requesting access to your Mindbody data.',
        desc: 'By signing in, <partnerName> will have access to your name, email address, and list of businesses linked to your Mindbody account.',
        formlabel: 'In addition, <partnerName> would like access to your:',
        cta: 'Approve and sign in',
        disclaimer: 'Note: <partnerName> CANNOT perform any transactions without your approval',
    },
    error: {
        generic: {
            header: 'OOPS!',
            subheader: 'Something went wrong please try again later.',
        },
        thirdPartyGeneric: {
            header: 'We had trouble signing you in',
            loginCTA: 'Sign in with Mindbody',
        },
        thirdPartyConnected: {
            header: 'You are not signed in',
            subheader: 'You are already connected with',
            loginCTA: 'Manage your Mindbody account',
        },
        noCoporateUserFound: {
            header: 'We had trouble signing you in',
            subheader: "Please contact your organization's SSO administrator",
        },
        corporateUserConflict: {
            header: 'This email address is already in use',
            subheader: "Please contact your organization's SSO administrator",
        },
        corporateUserNoPermission: {
            header: "You don't have permission to access this site",
            subheader: "Please contact your organization's SSO administrator",
        },
    },
    unsupported: {
        unsupportedBrowser: {
            header: 'Switch to a supported browser',
            desc: 'For the best experience, use the latest version of one of these:',
            chrome: 'Google Chrome',
            firefox: 'Mozilla Firefox',
            edge: 'Microsoft Edge',
            safari: 'Safari (for Mac)',
        },
        cookiesDisabled: {
            header: 'Enable Cookies',
            desc: 'In order to use this site, cookies must be enabled.',
        },
    },
};

export default language;
